import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var mirrorIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.5 22.5h15v-21h-15v21ZM19.5 0A1.5 1.5 0 0 1 21 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 22.5v-21A1.5 1.5 0 0 1 4.5 0h15Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.958 9-4.094 4.944-.01-.007s.707-.957.472-2.639l-.322-2.296H9.347l-2.261 6.513h1.755l1.035-2.995.341 2.992h1.148l2.402-2.913-1.02 2.913h1.758L16.751 9h-1.793Z"
})));

export { mirrorIcon as default };
//# sourceMappingURL=mirrorIcon.js.map
